import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { Partner, PartnerPayload, PartnerType } from './partner.model';
import { CustomerPayload } from './customer.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PartnerService {

  constructor(private httpClient: HttpClient) {}

  createPartner(partnerPayload: CustomerPayload | PartnerPayload) {
    const url = `${environment.apiHost}/Partner`;

    return this.httpClient.post(url, partnerPayload)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getAllPartnerList(customerId: string, isShowAll): Observable<Partner[]> {
    const url = `${environment.apiHost}/Partner/${customerId}/${isShowAll}`;

    return this.httpClient.get<Partner[]>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  editPartner(partnerId: string, partnerPayload: CustomerPayload | PartnerPayload) {
    const url = `${environment.apiHost}/Partner/${partnerId}`;

    return this.httpClient.put(url, partnerPayload)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  disablePartner(isEnable: boolean, partnerId: string) {
    const url = `${environment.apiHost}/BusinessUnit/${isEnable}/${partnerId}`;

    return this.httpClient.get(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getAllPartnerType(): Observable<PartnerType[]> {
    const url = `${environment.apiHost}/AppCategory/partnerType`;

    return this.httpClient.get<PartnerType[]>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

}
